import { takeEvery, put, all } from 'redux-saga/effects';
import * as languageActions from 'root/language/languageActions';


export function* languageSaga() {
    return yield all([takeEvery(languageActions.LANGUAGE_UPDATE_START, updateLanguage)]);
}


export function* updateLanguage(params: ReturnType<typeof languageActions.updateUserLanguage>) {
    const language = params.payload.userLanguage;
    try {
        yield put(languageActions.updateUserLanguageCompleted(language));
    } catch (error) {
        console.error(error);
        yield put(languageActions.updateUserLanguageError(error));
    }
}
